// extracted by css-extract-rspack-plugin
export default {"mailboxSelector":"InviteButton_mailboxSelector__VvdkF","mobile":"InviteButton_mobile__AJGJ9"};